let deferredPrompt = null;
const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => listener(deferredPrompt));
};

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    notify();
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

export const getPwaInstallPrompt = () => deferredPrompt;

export const subscribePwaInstallPrompt = (listener) => {
  listeners.add(listener);
  listener(deferredPrompt);
  return () => listeners.delete(listener);
};

export const clearPwaInstallPrompt = () => {
  deferredPrompt = null;
  notify();
};
